export const DEFAULT_PORT = 12721
export const MINIMUM_PORT = 9201
export const MAXIMUM_PORT = 65535

export const HOOK_PATH_MATCHING = {
  FULL: 'FULL',
  /** setting path 가 hook 결과를 포함 (model.includes(hook)) */
  INCLUDE: 'INCLUDE',
  /** setting path 가 포함 hook 결과에 포함 됨 (hook.includes(model)) */
  INCLUDED: 'INCLUDED',  
  HAS_PROPERTY: 'HAS_PROPERTY', 
}
